import React from 'react';
import { useIntl } from 'react-intl';
import { Icon } from 'ui';
import { StyledHomeInfoBar } from './style';
import useMarketType from 'utils/useMarketType';

const HomeInfoBar = () => {
  const intl = useIntl();
  const { isEmarket } = useMarketType();

  return (
    <StyledHomeInfoBar className={isEmarket ? 'emarket' : 'wholesale'}>
      <span className="market-tag">
        {intl.formatMessage({
          id: isEmarket ? 'general.e-market' : 'general.bizness',
        })}
      </span>
      <div className="container">
        <span className="home-info-products">
          <Icon name={'biodegradable-1'} type={'small'} />
          <span>{intl.formatMessage({ id: 'general.home_info_products' })}</span>
        </span>
        <span className="separator">|</span>
        <span className="home-info-site">
          <Icon name={'ng-header-icon'} type={'small'} />
          <a href={'https://novadagarsa.lv'} target={'_blank'} rel={'noreferrer'}>
            {intl.formatMessage({ id: 'general.home_info_site' })}
          </a>
        </span>
      </div>
    </StyledHomeInfoBar>
  );
};

export default HomeInfoBar;
